<template>
    <div>
        <generic-form-view
            rootPath="/v2/clients"
            :forms="forms"
            :columns="columns"
            :table_name="table_name"
            @onSubmitted="onSubmitted"
            @onViewExistRecord="onViewExistRecord"
            v-if="isNewRecord"
            >

          </generic-form-view>
    </div>

</template>

<script>
import TableMeta from './ClientTableMeta'
import GenericFormView from '@/views/base/GenericFormView'

export default {
  name: 'ClientEntryForm',
  components: {
    'generic-form-view': GenericFormView
    },
  data () {
    return {
        forms: TableMeta.input_view.forms,
        columns: TableMeta.columns,
        table_name: TableMeta.main_table_name,
        clientId: null
    }
  },
  computed: {
    isNewRecord () {
      return this.clientId == 'new';
    }
  },
  watch: {

  },
  methods: {
    onSubmitted (id) {
      this.$router.replace({path: `/v2/clients/${id}/view`});
    },
    onViewExistRecord (existId) {
      let routeData = this.$router.resolve({path: `/v2/clients/${existId}/view`, query: {  }});
      window.open(routeData.href, '_blank');
    }
  },
  mounted () {
      this.clientId = this.$route.params.id;

      if(this.clientId) {
        // this is an existing record, we should 
      }
  }
}
</script>

